import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLeadNotificationAction } from "../../../../../store/reducers/reviewSlice";
import { LEAD_NOTIFICATION_TABLE_HEADER } from "../allFieldUtil";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { Lens, MoreVert as MoreIcon } from "@mui/icons-material";
import Validation from "../../../../../utils/Validation";
import Notification from "../../../../../components/common/notification/Notification";
import TableDesign from "../../../../../components/common/table/TableDesign";
import ManageLeadNotification from "./ManageLeadNotification";

const GeneralLeadNotification = () => {
  const dispatch = useDispatch();
  const { leadNotification } = useSelector((state: any) => state.review);
  type FormDataType = {
    message: string;
    color: string;
    forward_days: string;
    old_days: string;
    [key: string]: string;
  };
  const [anchorEl, setAnchorEl] = useState(null);
   const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const openDown = Boolean(anchorEl);
  const [open, setOpen] = useState(false);
  const [modelShow, setModelShow] = useState(false);
  const [formData, setFormData] = React.useState<FormDataType>({
    message: "",
    color: "",
    forward_days: "",
    old_days: "",
  });

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
  ]: any = Validation({
    message: formData?.message,
    color: formData?.color,
    forward_days: formData?.forward_days,
    old_days: formData?.old_days,
  });

  useEffect(() => {
    dispatch(getLeadNotificationAction());
  }, []);

    const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditOpen = () => {
      setModelShow(true);
      handleClose();
  };

  return (
    <>
      <Notification />
      <Box
        sx={{
          bgcolor: "#fff",
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          overflow: "hidden",
          marginTop: "10px",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "6px 8px",
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: "600" }}>
            Client Lead Notification Settings
          </Typography>
        </Box>

        {/* Table */}
        <Box
          sx={{
            bgcolor: "#fff",
            height: { xs: "auto", sm: "auto" },
            border: "1px solid #d1cfcf",
            borderRadius: "5px",
            overflow: "auto",
          }}
        >
          <TableDesign
            tableHeadings={LEAD_NOTIFICATION_TABLE_HEADER}
            tableHeadColor={"#02906f"}
            cellColor={"#fff"}
            pagination={null}
            isLoader={false}
            stickyHeader={true}
            filterOption={null}
            setFilterOption={() => {}}
            extraCSS={{ height: "100%" }}
          >
            {leadNotification?.length > 0 ? (
              leadNotification.map((item: any, index: number) => (
                <TableRow
                  key={item.id}
                  sx={{
                    height: 36,
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                    },
                  }}
                >
                  <TableCell sx={{ py: 0.5 }}>{item?.message_id}</TableCell>

                  <TableCell sx={{ py: 0.5 }}>{item.message}</TableCell>
                  <TableCell sx={{ py: 0.5, backgroundColor: item.color }}>{item.color}</TableCell>
                  <TableCell sx={{ py: 0.5 }}>
                    {item.sources}
                  </TableCell>
                
                  <TableCell align="center" sx={{ py: 0.5 }}>
                    <IconButton
                      sx={{ padding: "0px" }}
                      size="small"
                      id="basic-button"
                      aria-controls={openDown ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={openDown ? "true" : undefined}
                      onClick={(e) => {
                        handleClick(e);
                        setSelectedRow(item);
                      }}
                    >
                      <MoreIcon />
                    </IconButton>
                    <Menu
                      sx={{
                        boxShadow: "none",
                        border: "2px solid #eeecef",
                        "& .MuiPaper-root": {
                          boxShadow: "none", // Removes shadow on the paper element of the menu
                          border: "2px solid #eeecef",
                        },
                        top: "0px",
                      }}
                      // className={classes.menuBox}
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={openDown}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem onClick={() => handleEditOpen()}>
                        <Lens
                          style={{
                            height: "4px",
                            width: "4px",
                            marginRight: "4px",
                          }}
                        />
                        Edit
                      </MenuItem>

                      
                    </Menu>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={LEAD_NOTIFICATION_TABLE_HEADER.length}>
                  <Box
                    sx={{
                      height: "20vh",
                      display: "flex",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <span
                      style={{
                        position: "absolute",
                        fontSize: "1rem",
                        color: "#4A4A4A",
                        // top: "100px",
                      }}
                    >
                      No Client Lead Notification Found.
                    </span>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableDesign>
        </Box>
      </Box>
      {/* {open && (
        <AlertPopup
          open={open}
          onHide={onHide}
          title={"Delete Review Source"}
          content={popupContent.delete}
          submitHandler={handleDeleteConfirm}
        />
      )} */}
      {modelShow && (
        <ManageLeadNotification
          open={modelShow}
          onHide={() => setModelShow(false)}
          title={"Edit Lead Notification"}
          selectUser={selectedRow}
          />
      )}
    </>
  );
};

export default GeneralLeadNotification;
